export const HOSPEDAY_TYPES = {
  HOTEL: 'HOTEL',
  FAMILY_FRIEND: 'FAMILYFRIEND',
  RENT: 'RENT',
};
